export const newArrivals = [
  {
    id: 1,
    title: "Candyland Birthday Balloon Decor",
    price: 3599,
    originalPrice: 3899,
    image: "/images/NewArrivals/IMG1_286.webp"
  },
  {
    id: 2,
    title: "Astronaut & Rocket Space Birthday Decor",
    price: 3799,
    image: "/images/NewArrivals/img_381.webp"
  },
  {
    id: 3,
    title: "10th Anniversary Car Boot Decor",
    price: 1699,
    image: "/images/NewArrivals/img_256.webp"
  },
  {
    id: 4,
    title: "1st Birthday Balloon Decor with Golden Stars",
    price: 2299,
    originalPrice: 2530,
    image: "/images/NewArrivals/img_118.webp"
  },
  {
    id: 5,
    title: "18th Birthday Black & Silver Decor with Bottle Arch",
    price: 2599,
    originalPrice: 2860,
    image: "/images/NewArrivals/img_448.webp"
  },
  {
    id: 6,
    title: "Boss Baby Naming Ceremony Decor",
    price: 6299,
    image: "/images/NewArrivals/img_259.webp"
  },
  {
    id: 7,
    title: "Black, Silver & Blue Birthday Balloon Room Decor",
    price: 1699,
    originalPrice: 1870,
    image: "/images/NewArrivals/img_393.webp"
  },
  {
    id: 8,
    title: "Celestia Naming Ceremony Balloon Decor",
    price: 5699,
    image: "/images/NewArrivals/img_118.webp"
  }
];

export const featuredCollection = [
  {
    id: 9,
    title: "Golden Car Boot Birthday Balloon Decor",
    price: 1699,
    image: "/images/FeaturedCollection/img_424.webp"
  },
  {
    id: 10,
    title: "Royal White & Golden Balloon Decor",
    price: 3199,
    originalPrice: 3520,
    image: "/images/FeaturedCollection/img_372.webp"
  },
  {
    id: 11,
    title: "Red & White Romantic Birthday Decor",
    price: 1999,
    image: "/images/FeaturedCollection/img_368.webp"
  },
  {
    id: 12,
    title: "Rose Gold & Pink Birthday Balloon Arch Decor",
    price: 2499,
    originalPrice: 2750,
    image: "/images/FeaturedCollection/img_369.webp"
  },
  {
    id: 13,
    title: "Pink & Golden Balloon Decor",
    price: 2399,
    originalPrice: 2640,
    image: "/images/FeaturedCollection/Happy_Birthday_13.webp"
  },
  {
    id: 14,
    title: "Rainbow Birthday Decor",
    price: 2199,
    originalPrice: 2420,
    image: "/images/FeaturedCollection/img_133.webp"
  },
  {
    id: 15,
    title: "Rainbow Theme Birthday Decor",
    price: 2299,
    originalPrice: 2530,
    image: "/images/FeaturedCollection/img_375.webp"
  }
];

export const specialOne = [
  {
    id: 16,
    title: "Elegant Golden & White Proposal Decor",
    price: 6999,
    image: "/images/Special/Gemini_Generated_Image_umifhmumifhmumif.webp"
  },
  {
    id: 17,
    title: "Blush Dreams Naming Ceremony Decor",
    price: 7199,
    image: "/images/Special/Gemini_Generated_Image_5wn6g55wn6g55wn6.webp"
  },
  {
    id: 18,
    title: "Pink-Blue Bloom Baby Shower Decor",
    price: 5899,
    rating: 5.0,
    image: "/images/Special/Gemini_Generated_Image_ysm5t1ysm5t1ysm5.webp"
  },
  {
    id: 19,
    title: "The Naming Nook Ring Decor",
    price: 5399,
    image: "/images/Special/Gemini_Generated_Image_y6hvrry6hvrry6hv.webp"
  },
  {
    id: 20,
    title: "Royal Rapunzel Ring Decor",
    price: 6699,
    image: "/images/Special/Gemini_Generated_Image_nhw5c7nhw5c7nhw5.webp"
  },
  {
    id: 21,
    title: "Hello Kitty Birthday Balloon Decor",
    price: 5699,
    image: "/images/Special/Gemini_Generated_Image_wpu8d9wpu8d9wpu8.webp"
  },
  {
    id: 22,
    title: "Princess Theme Ring Balloon Decor",
    price: 6599,
    image: "/images/Special/Gemini_Generated_Image_281mar281mar281m.webp"
  }
];

export const highlights = {
  birthday: [
    {
      id: 23,
      title: "Golden Car Boot Birthday Balloon Decor",
      price: 1699,
      image: "/images/FeaturedCollection/img_424.webp"
    },
    {
      id: 24,
      title: "Royal White & Golden Balloon Decor",
      price: 3199,
      image: "/images/FeaturedCollection/img_372.webp"
    },
    {
      id: 25,
      title: "Red & White Romantic Birthday Decor",
      price: 1999,
      image: "/images/FeaturedCollection/img_368.webp"
    },
    {
      id: 26,
      title: "Rose Gold & Pink Birthday Balloon Arch Decor",
      price: 2499,
      image: "/images/FeaturedCollection/img_369.webp"
    },
    {
      id: 27,
      title: "Pink & Golden Balloon Decor",
      price: 2399,
      image: "/images/FeaturedCollection/Happy_Birthday_13.webp"
    }
  ],
  anniversary: [
    {
      id: 28,
      title: "Golden Glow Car Boot Decor",
      price: 1699,
      image: "/images/FeaturedCollection/img_424.webp"
    },
    {
      id: 29,
      title: "I Love You Balloon Surprise Decor",
      price: 1899,
      image: "/images/FeaturedCollection/img_368.webp"
    },
    {
      id: 30,
      title: "Purple & White Anniversary Decor",
      price: 1599,
      image: "/images/FeaturedCollection/img_372.webp"
    },
    {
      id: 31,
      title: "Mr & Mrs White Balloon Decor",
      price: 2499,
      image: "/images/FeaturedCollection/img_369.webp"
    },
    {
      id: 32,
      title: "10th Anniversary Car Boot Decor",
      price: 1699,
      image: "/images/NewArrivals/img_256.webp"
    }
  ],
  babyShower: [
    {
      id: 33,
      title: "Whimsical Pastel Baby Shower Decor",
      price: 5499,
      image: "/images/ThemeImages/baby_shower_7b10b011-9dd4-427b-858e-4d0f7363c27a.webp"
    },
    {
      id: 34,
      title: "Boy or Girl Footprint Fun Decor",
      price: 5199,
      image: "/images/ThemeImages/welcome_baby_356973c5-d3b8-45c3-bde9-2d4814f67ec9.webp"
    },
    {
      id: 35,
      title: "Pink & Blue Baby Shower Decor",
      price: 4199,
      image: "/images/Special/Gemini_Generated_Image_ysm5t1ysm5t1ysm5.webp"
    },
    {
      id: 36,
      title: "Pastel Dreams Baby Shower decor",
      price: 4599,
      image: "/images/Special/Gemini_Generated_Image_5wn6g55wn6g55wn6.webp"
    },
    {
      id: 37,
      title: "Blissful Baby Shower Arch Decor",
      price: 2099,
      image: "/images/Special/Gemini_Generated_Image_y6hvrry6hvrry6hv.webp"
    }
  ],
  gifting: [
    {
      id: 38,
      title: "Blue Jewellery Organisers Box",
      price: 295,
      image: "/images/GiftImages/Gemini_Generated_Image_2xa7xy2xa7xy2xa7.webp"
    },
    {
      id: 39,
      title: "Multipurpose Paper Boxes Set of 10 Kit",
      price: 241,
      image: "/images/GiftImages/Gemini_Generated_Image_lv8ckxlv8ckxlv8c.webp"
    },
    {
      id: 40,
      title: "Knot Pearl Korean Earring",
      price: 169,
      image: "/images/GiftImages/Gemini_Generated_Image_qisx0hqisx0hqisx.webp"
    },
    {
      id: 41,
      title: "Reusable Coffee Cup-3pcs",
      price: 379,
      image: "/images/GiftImages/Gemini_Generated_Image_yc7b2lyc7b2lyc7b.webp"
    },
    {
      id: 42,
      title: "Hamper Boxes for Gift Empty-3pcs",
      price: 835,
      image: "/images/GiftImages/Gemini_Generated_Image_aj4ariaj4ariaj4a.webp"
    }
  ]
};

